import { createRouter, createWebHistory } from "vue-router";
import SplashScreen from "../views/SplashScreen.vue";
import ChooseScreen from "../views/ChooseScreen.vue";
import BankerStartGame from "../views/BankerStartGame.vue";
import PlayerStartGame from "../views/PlayerStartGame.vue";
import GameDashboard from "../views/GameDashboard.vue";

const routes = [
  { path: "/splash", name: "Splash", component: SplashScreen },
  { path: "/choosescreen", name: "Choose", component: ChooseScreen },
  {
    path: "/banker/start",
    name: "BankerStartGame",
    component: BankerStartGame,
  },
  {
    path: "/player/start",
    name: "PlayerStartGame",
    component: PlayerStartGame,
  },
  {
    path: "/game/dashboard",
    name: "GameDashboard",
    component: GameDashboard,
  },
  { path: "/", redirect: "/splash" }, // Redirect root to splash
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
